import React, { Fragment, useEffect, useRef, useState } from "react";
import Styles from "./WorkingOp.module.css";
import * as Icon from "react-bootstrap-icons";

const WorkingOp = () => {
  return (
    <section className={Styles.loadingSec}>
      <span className={Styles.loader}></span>
      <p>Please Wait</p>
    </section>
  );
};

export default WorkingOp;
